<template>
  <v-list>
    <v-dialog v-model="showChangePasswordModal" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item dense v-on="on" v-bind="attrs">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Byt lösenord</v-list-item-title>
        </v-list-item>
      </template>
      <UserChangePasswordModal
        @close="showChangePasswordModal = false"
        v-if="showChangePasswordModal"
      />
    </v-dialog>
  </v-list>
</template>

<script>
import UserChangePasswordModal from './UserChangePasswordModal'

export default {
  name: 'UserContextMenu',

  components: {
    UserChangePasswordModal
  },

  data() {
    return {
      showChangePasswordModal: false
    }
  }
}
</script>
